import React from 'react';

import CalendarIcon from 'icons/calendar.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ActionsPill from 'components/application/ActionsPill';

import { formatDate, isBefore } from 'components/helpers/dates';

export default function TrainingBookings({
  booking,
  course,
  currentTrainingStatus,
  isBookingTooltipDisplayable,
  isEligibleForManualBooking,
  onAddBooking,
  onShowBooking,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'training.TrainingBookings',
  });

  const { t: i18nTCommon } = useTranslation('common');

  if (booking) {
    const {
      attributes: { date },
      id: bookingId,
    } = booking;

    const hasDateReached =
      date &&
      !isBefore({
        date: new Date(),
        dateToCompare: date,
      });

    const tooltipText =
      isBookingTooltipDisplayable &&
      (hasDateReached ?
        i18nT('bookingTooltip.dateReached')
      : i18nT('bookingTooltip.booked'));

    return (
      <ActionsPill
        color={hasDateReached ? 'cyan' : 'green'}
        displayText={
          date ?
            i18nTCommon('bookings.bookedFor', {
              date: formatDate({ date, format: 'd MMM yyyy' }),
            })
          : i18nTCommon('bookings.booked')
        }
        icon={<CalendarIcon height={16} width={16} />}
        onClick={() => onShowBooking(bookingId)}
        tooltipText={tooltipText}
      />
    );
  }

  if (isEligibleForManualBooking) {
    const tooltipText = {
      expired: i18nTCommon('training.trainingIsExpiredAndRequiresBooking'),
      expiring: i18nTCommon(
        'training.trainingIsExpiringSoonAndRequiresBooking',
      ),
      missing: i18nTCommon('training.trainingIsMissingAndRequiresBooking'),
    }[currentTrainingStatus];

    return (
      <ActionsPill
        color='cyan'
        displayText={i18nTCommon('training.bookTraining')}
        icon={<CalendarIcon height={16} width={16} />}
        onClick={() => onAddBooking({ course })}
        tooltipText={tooltipText}
      />
    );
  }

  return null;
}

TrainingBookings.propTypes = {
  booking: PropTypes.object,
  course: PropTypes.object,
  currentTrainingStatus: PropTypes.string,
  isBookingTooltipDisplayable: PropTypes.bool,
  isEligibleForManualBooking: PropTypes.bool,
  onShowBooking: PropTypes.func,
  onAddBooking: PropTypes.func.isRequired,
};
